/**
 * Extrait le nom de fichier d'un header `Content-Disposition`
 * (ex: `attachment; filename=fiches-collaborateurs.xlsx`).
 *
 * Nécessite que l'API expose le header en CORS (`exposeHeaders`), sinon le
 * navigateur le masque en cross-origin et le `fallback` est utilisé.
 */
export const extractContentDispositionFilename = (
  contentDisposition: string | undefined,
  fallback: string,
): string => {
  if (!contentDisposition) return fallback
  const match = /filename="?([^";]+)"?/i.exec(contentDisposition)
  return match?.[1] ?? fallback
}
